import CreateWindow from "../puzzleWindow";
import images from "./*.jpg";
import { html, render } from "lit-html";
import "./index.css";
import { tips, clearAllTips } from "~src/tips/index.js";
import { userChoiceTracker } from "../../helpers/userChoiceTracker";
import {exitButtonPosition} from "../../helpers/exitButtonPosition"
import imagesLoaded from "imagesloaded"
let doorOpened = false;
export const wallSwitchState = { active: false, pressed: false, imageLoaded: false };
const FlatPuzzle = function (openExit, sounds) {
  if (userChoiceTracker.retrieve()["flatPuzzle2"]) {
    // email
    tips.safariPoster.clear();
  }

  const whichImage = () => {
    let image = null;
    // this tells us how many of fake news puzzles has been solved. The image will vary depending on this.
    const solved = userChoiceTracker.fakeNewsSolved();
    image = images[JSON.stringify(solved)];

    const { pressed } = wallSwitchState;
    if (pressed) {
      tips.safariPoster2.clear();
      image = images.opened;
    }

    return image;
  };
  let timeout;
  const { element, exit } = CreateWindow({
    exitCallback: () => {
      if (wallSwitchState.active && !wallSwitchState.pressed) {
        tips.safariSwitch.setTime(0, {override: true})
        wallSwitchState.imageLoaded = false
      } 
    },
  });
  const clickhandler = () => {
    clearInterval(timeout);
    if (wallSwitchState.active && wallSwitchState.imageLoaded) {
      wallSwitchState.pressed = true;
    } else {
      window.scene.getSoundByName("switchStuck")?.play?.();
      return null;
    }

    if (wallSwitchState.pressed) {
      if (!doorOpened) openExit();
      doorOpened = true;
      if (sounds) {
        sounds();
      }
      clearAllTips()
      userChoiceTracker.processAnswer("endSwitch", true);
      timeout = setTimeout(exit, 1000);

  

    }
    render(markup(), element);
  };
  const markup = () => html`
    <div
      @click=${clickhandler}
      class="wall-switch-container"
      style=""
    >
      <img @load=${() => setTimeout(() => {wallSwitchState.imageLoaded = true}, 1000)} src=${whichImage()} class="wall-switch" />
    </div>
  `;
  // CreateWindow palauttaa modaali-ikkunan noden, johon siis rendataan

    if (wallSwitchState.active) {
        tips.safariSwitch.setTime(15)
      } 
  render(markup(), element);

  imagesLoaded(".wall-switch-contaner", () => setTimeout(() => {wallSwitchState.imageLoaded = true}, 1000))

  exitButtonPosition()
};

export default FlatPuzzle;
